module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-dialog', {
    attrs: {
      "dialogClass": "pop",
      "open": _vm.display
    },
    on: {
      "close": _vm.close
    }
  }, [(false) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.msg == '取消订单openPop') ? _c('div', {
    staticClass: "msg",
    domProps: {
      "innerHTML": _vm._s(_vm.CancelOrderMsg)
    }
  }) : _c('div', {
    staticClass: "msg"
  }, [_vm._v(" " + _vm._s(_vm.msg) + " ")]), _vm._v(" "), (_vm.onlyOk) ? _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    staticClass: "btn center",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("确定")])]) : _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    staticClass: "btn left",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "btn right",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73bfa3ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop.vue
// module id = 194
// module chunks = 17 18